// HelpTier groups every article into one of four buckets surfaced in the
// /help sidebar and in the contextual drawer's tier badge.
export type HelpTier = 'getting-started' | 'features' | 'reference' | 'concepts';

export interface HelpArticleMeta {
  slug: string;
  title: string;
  summary: string;
  tier: HelpTier;
  category: string;
  tags: string[];
  relatedArticles: string[];
  lastVerified: string;
  adminOnly: boolean;
}

export interface HelpSearchEntry {
  slug: string;
  title: string;
  summary: string;
  tags: string[];
  body: string;
}

// HelpAlignment is the manually-maintained marker recording the last time the
// help center was reviewed against the rest of the platform. It lives in the
// committed alignment.json (NOT generated) and is stamped via `npm run
// help:align`. The recorded commit lets a reviewer diff only what shipped
// since (`git diff <commit>..HEAD`) instead of re-reading everything.
export interface HelpAlignment {
  commit: string; // full git SHA the help center was last aligned against
  timestamp: string; // ISO 8601 timestamp of that alignment
}

export const HELP_TIER_LABELS: Record<HelpTier, string> = {
  'getting-started': 'Getting Started',
  features: 'Features',
  reference: 'Reference',
  concepts: 'Concepts',
};

export const HELP_TIER_ORDER: HelpTier[] = [
  'getting-started',
  'features',
  'reference',
  'concepts',
];
